if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {
  
      constructor() {
        super()
        this.handleProductCardSwatchClick();
      }

      handleInsideLinkClick = (event) => {
        event.preventDefault();
      }

      fetchProduct(event) {

        event.preventDefault();

        //const isWithinSlider = this.closest('fostr-slider') !== null
        const isWithinCartDrawer = this.closest('#CartDrawer') !== null
        const isProductPage = document.body.classList.contains('product')
        const isMobile = window.innerWidth < 750
    
        /*
        if ((isWithinSlider && isProductPage && isMobile) || (isWithinSlider && isWithinCartDrawer && isMobile)) {
          return
        }
        */

        fetch(event.target.dataset.productUrl + '?view=card-product--swatches')
        .then(response => response.text())
        .then(text => {

          const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector('product-card').innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }

        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          // Refreshing yotpo star rating module
          var api = new Yotpo.API(yotpo);
          if(api) {
            api.refreshWidgets();
          }

          // refreshing swym wishlist heart button
            document.dispatchEvent(new CustomEvent("swym:product-card-loaded"));
        });
      } 

      handleProductCardSwatchClick() {
        const swatches = this.querySelectorAll('product-group product-group-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.fetchProduct.bind(this));
          swatch.querySelector('a.product-group--item')?.classList.add('js-load');
          swatch.querySelector('a.product-group--item')?.addEventListener('click', this.handleInsideLinkClick);
        });
      }
  
    }
  
    customElements.define('product-card', ProductCard)
  }
  